module.exports = __webpack_public_path__ + "img/experimental.f34322d7.svg";